import React, { useState } from 'react';

function DownloadButton({ downloaded, setDownloaded }) {
    const [downloadStatus, setDownloadStatus] = useState('not started');
    const [downloadProgress, setDownloadProgress] = useState(0);
    
    const downloadAPK = async () => {
        try {
          setDownloadStatus('downloading');
          const apiUrl = 'https://kosh-testing-app.s3.ap-south-1.amazonaws.com/app-release.apk';
          setDownloadStatus('started');
    
          // Fetch the APK file from the API
          const response = await fetch(apiUrl);
          if (!response.ok) {
            setDownloadStatus('failed');
            window.alert('Download failed! Please retry');
            throw new Error(`HTTP error! status: ${response.status}`);
          }
    
          const filename = 'kosh.apk';
          const contentLength = response.headers.get('content-length');
          const chunks = [];
          let downloadedBytes = 0;
          const reader = response.body.getReader();
    
          // Read the data in chunks and update the download progress
          while (true) {
            const { done, value } = await reader.read();
            if (done) {
              break;
            }
            chunks.push(value);
            downloadedBytes += value.length;
            setDownloadProgress((downloadedBytes / contentLength) * 100);
          }
    
          // Create a Blob from the chunks
          const blob = new Blob(chunks);
    
          // Create an object URL for the Blob
          const objectUrl = window.URL.createObjectURL(blob);
    
          // Create an anchor element and trigger the download
          const anchor = document.createElement('a');
          anchor.href = objectUrl;
          anchor.download = filename;
          anchor.click();
    
          // Clean up the DOM and release the object URL
          window.URL.revokeObjectURL(objectUrl);
    
          setDownloadStatus('complete');
          setDownloaded(true);
          setDownloadProgress(0);
        } catch (error) {
          console.error('Error downloading APK:', error);
          setDownloadStatus('failed');
          setDownloadProgress(0);
        }
      };

    let downloadButtonText;
    if (downloadStatus == 'started') downloadButtonText = 'Downloading'
    else if (downloadStatus == 'not started' || !downloaded) downloadButtonText = 'Download'
    else if (downloadStatus == 'complete') downloadButtonText = 'Download Completed'
    return (
        <div style={{ width: '100%' }}>
            <button onClick={downloadAPK} style={{
                width: '98%', height: 34, fontSize: 16, fontWeight: 'bold', backgroundColor: downloaded ? 'rgb(232, 243, 255)' : '#01875f',
                borderWidth: 0, color: downloaded ? 'black' : 'white', borderRadius: 17,
            }} disabled={downloadStatus == 'started' || downloadStatus == 'complete'}>{downloadButtonText}{' '}{downloadProgress > 0 && `(  ${downloadProgress.toFixed(1)}%)`}</button>
        </div>
    );
}
export default DownloadButton;